export const DOSTAVA_V1ResourcesDE: DOSTAVA_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  errorMissingInput: "Bitte füllen Sie alle Felder aus",
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
  },
  input: {
    signatureTitle: "Unterschrift",
    datum: {
      label: "Datum",
      placeholder: "Bitte geben Sie das Datum ein",
      name: "datum",
    },
    ispravnaPosiljka: {
      label: "Ist die Sendung korrekt?",
      placeholder: "Bitte geben Sie an, ob die Sendung korrekt ist",
      name: "ispravnaPosiljka",
    },
    dokument: {
      label: "Dokument",
      placeholder: "Bitte geben Sie das Dokument ein",
      name: "dokument",
      description: () => (
        <>
          <h4>Dateien hier ablegen oder zum Hochladen klicken.</h4>
          <span className="text-muted font-13">Nur Bilder, max 6MB</span>
        </>
      ),
    },
    korektivnaMjera: {
      label: "Korrekturmaßnahme",
      placeholder: "Bitte geben Sie die Korrekturmaßnahme ein",
      name: "korektivnaMjera",
    },
    potpisPrimalac: {
      label: "Bitte unterschreiben Sie die Lieferung",
      placeholder: "",
      name: "potpisPrimalac",
    },
    primalac: {
      label: "Empfängername",
      placeholder: "Bitte geben Sie den Empfängernamen ein",
      name: "primalac",
    },
    primjedba: {
      label: "Bemerkung/Notiz",
      placeholder: "Bitte geben Sie eine Bemerkung ein",
      name: "primjedba",
    },
    brojRacuna: {
      label: "Rechungs-/Lieferscheinnummer",
      placeholder: "Bitte geben Sie die Rechungs-/Lieferscheinnummer ein",
      name: "brojRacuna",
    },
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
  dropdownOptions: {
    da: "Ja",
    ne: "Nein",
    undefined: "Bitte wählen Sie ein Feld aus",
  },
};

interface InputField {
  label: string;
  placeholder: string;
  name: string;
  description?: () => JSX.Element;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ispravnaPosiljka: InputField;
  dokument: InputField;
  korektivnaMjera: InputField;
  potpisPrimalac: InputField;
  primalac: InputField;
  primjedba: InputField;
  brojRacuna: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IDropdownOptions {
  da: string;
  ne: string;
  undefined: string;
}

interface IErrors {
  registerPic: string;
}

export interface DOSTAVA_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  dropdownOptions: IDropdownOptions;
  errors: IErrors;
}
